<template>
	<div>
		<Logo></Logo>
		<el-container style="width: 400px;  margin:auto;">
			<el-form ref="form" class="login-form" :rules="rules" :model="form">
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="form.email"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input v-model="form.password" type="password" @keyup.enter.native="handleLogin"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="handleLogin" style="width: 100%;" type="primary" :loading="logining">登录</el-button>
				</el-form-item>
			</el-form>
		</el-container>
	</div>
</template>

<script>
	import Logo from '../components/Logo.vue'
	import {
		mapMutations
	} from "vuex";
	import {
		login,
		// getAPPInfo
	} from '../api/index.js'

	export default {
		data() {
			return {
				form: {
					email: '',
					password: ''
				},
				logining: false,
				rules: {
					email: [{
						required: true,
						message: '请输入邮箱',
						type: 'email'
					}],
					password: [{
						required: true,
						message: '请输入密码'
					}]
				}
			}
		},
		components:{
			Logo
		},
		methods: {
			...mapMutations([
				"setUser"
			]),
			handleLogin() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.logining = true
						login(this.form.email, this.form.password)
							.then(res => {
								console.log(res)
								if (res.data.code === 200) {
									const {
										email,
									} = res.data
									localStorage.setItem('user', email)
									this.setUser(email)
									this.$router.push("/setBasicInfo")
									// getAPPInfo({email:email}).then(res=>{
									// 	console.log(res)
									// 	if(res.data.code==200){
									// 		if(res.data.web_app_list.length==0){
									// 			this.$router.push("/illustrate")
									// 		}else{
									// 			//存储已有的第一个app信息
									// 		}
									// 	}
									// })
								} else {
									this.$message.error('账号或者密码错误')
								}
							})
							.catch(err => {
								console.log(err)
								alert('登陆失败')
							})
							.then(() => {
								this.logining = false
							})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	.page {
		width: 100%;
		height: 100%;
	}
	.login-form {
		padding-top: 120px;
		width: 100%;
	}

</style>
